import BaseViewStore from './BaseViewStore';
import { action, observable } from 'mobx';
import _ from 'lodash';

class BaseStepViewStore extends BaseViewStore {
	@observable config = [];
	@observable currentStep = null;

	constructor(rootStore, config) {
		super(rootStore);
		this.config = config;
		this.currentStep = this.config[0];
	}

	@action.bound
	checkValidity = () => {
		_.each(this.config, step => {
			this.form
				.$(`${step.name}`)
				.validate()
				.then(({ isValid }) => {
					step.isValid = isValid;
				});
		});
		this.form.invalidate();
		this.form.showErrors();
	};

	@action.bound
	checkValidityForSteps = stepNumbers => {
		_.each(this.config, step => {
			if (stepNumbers.includes(step.order)) {
				this.form
					.$(`${step.name}`)
					.validate()
					.then(({ isValid }) => {
						step.isValid = isValid;
					});
			}
			if (!step.isValid) {
				this.form.invalidate();
				this.form.showErrors();
			}
		});
	};

	@action.bound
	onNextStep = (currentStep, stepDirection) => {
		let nextStep = this.config[currentStep.order - 1 + stepDirection]; // -1 to get Actual Index
		if (nextStep) {
			this.navigateToStep(nextStep);
		}
	};

	@action.bound
	navigateToStep = nextStep => {
		this.checkValidityForSteps([this.currentStep.order]);
		this.currentStep = nextStep;
	};
}

export default BaseStepViewStore;
